export default __webpack_public_path__ + "static/media/Licences.d2528217.svg";